export enum EnumHomeTrackingEvents {
  TDAE_INTEREST_HOMEPAGE = 'TDAE_INTEREST_HOMEPAGE',
}
